import PGlobal from "./PGlobal";
import PButton from "./PButton";
import Timeline from "./Timeline";
import ModeButton from "./ModeButton";
import M from './M';
import Keyboard from "./keyboard";

export default class EditorTimeline {
    constructor(container) {
        PGlobal.setParent(container);
        PGlobal.app = new PIXI.Application();
        //context丢失后ticker仍每帧渲染到死context上（INVALID_OPERATION刷屏）：lost停帧。
        //不在restored时自动恢复：PIXI4重建GL不完整，恢复后渲染仍报INVALID刷屏，只能停帧等刷新
        PGlobal.app.view.addEventListener('webglcontextlost', () => {
            if (PGlobal.app && PGlobal.app.ticker) PGlobal.app.ticker.stop();
        });
        PGlobal.parent.appendChild(PGlobal.app.view);
        PGlobal.stage = PGlobal.app.stage;
        PGlobal.app.renderer.backgroundColor = 0x515151;
        PGlobal.app.renderer.autoResize = true;

        this.isPlaying = false;
        this.isAudioTrkPlaying = false;
        this.currentTime = 0;
        this.totalTime = 0;
        this.resize();
    }

    start(platform, moduleId, moduleName, resBase) {
        PGlobal.app.ticker.add(delta => this.appLoop(delta));
        PGlobal.loader.add("mainUI", resBase + "ui/editor_timeline.json").load(
            () => this.setup());
        PGlobal.platform = platform;
        this.moduleId = moduleId;
        this.moduleName = moduleName;
    }

    resize() {
        let screenRect = PGlobal.parent.getBoundingClientRect();
        let screenWidth = Math.floor(screenRect.width);
        let screenHeight = Math.floor(screenRect.height);
        if (screenWidth != PGlobal.app.renderer.width || screenHeight != PGlobal.app.renderer.height) {
            PGlobal.app.renderer.resize(screenWidth, screenHeight);
            PGlobal.stageWidth = PGlobal.app.renderer.width;
            PGlobal.stageHeight = PGlobal.app.renderer.height;
            this.onResize();
        }
    }

    appLoop(delta) {
        PGlobal.now = new Date().getTime();
        this.resize();

        if(this.isPlaying || this.isAudioTrkPlaying) {
            this.currentTime += PGlobal.now - this.lastTick;
            this.lastTick = PGlobal.now;
            this.freshTime();
        }
    }

    onResize() {
        if(this.save_bt) {
            this.save_bt.x = PGlobal.stageWidth-this.save_bt.width;
        }
        if(this.play_bt) {
            this.play_bt.x = 25;
            this.play_bt.y = (PGlobal.stageHeight - this.play_bt.height)/2 - 6;
        }
        if(this.stop_bt) {
            this.stop_bt.x = this.play_bt.x;
            this.stop_bt.y = this.play_bt.y;
        }
        if(this.time_tf) {
            this.time_tf.x = this.play_bt.x + this.play_bt.width/2;
            this.time_tf.y = this.play_bt.y + this.play_bt.height + 2;
        }
        if(this.timeline) {
            this.timeline.x = this.play_bt.x + this.play_bt.width + 25;
            this.timeline.y = 0;
            this.timeline.resize(this.save_bt.x - this.timeline.x, PGlobal.stageHeight);
        }
        if(this.modeButton) {
            this.modeButton.x = 4;
            this.modeButton.y = 4;
        }
    }

    setup() {
        this.clear();

        this.play_bt = new PButton(["play_normal", "play_hover", "play_click", "play_disabled"]);
        PGlobal.stage.addChild(this.play_bt);
        this.play_bt.on("click", () => this.onPlayClick());

        this.stop_bt = new PButton(["stop_normal", "stop_hover", "stop_click", "stop_disabled"]);
        this.stop_bt.on("click", () => this.onStopClick());

        this.time_tf = new PIXI.Text("00:00/00:00", {fontFamily : 'Arial', fontSize: 12, fill : 0xD1D1D1, align : 'center'});
        this.time_tf.anchor.x = 0.5;
        PGlobal.stage.addChild(this.time_tf);

        this.save_bt = new PButton(["confirm_normal", "confirm_hover", "confirm_click", "confirm_disabled"]);
        this.save_bt.on("click", () => this.onSaveClick());
        this.save_bt.enable = false;
        PGlobal.stage.addChild(this.save_bt);

        this.timeline = new Timeline();
        PGlobal.stage.addChild(this.timeline);
        this.timeline.onTimeChange = (time) => this.onTimelineTimeChange(time);

        this.modeButton = new ModeButton();
        PGlobal.stage.addChild(this.modeButton);
        this.modeButton.on("click", (e) => {
            this.modeButton.mode = this.modeButton.mode == "video" ? "audio" : "video";
            this.timeline.changeMode(this.modeButton.mode);
            PGlobal.m.send(SCENE + BGMUSIC, 2, 14, new proto.com.proto.s.MString([this.modeButton.mode]));
        })

        this.onResize();

        PGlobal.m = new M(this.moduleId, this.moduleName);
        PGlobal.m.onDomReady = () => this.onDomReady();

        this.space = new Keyboard(32);
        this.space.release = () => this.onSpaceClick();
    }

    clear() {
        PGlobal.stage.removeChildren();
        this.isPlaying = false;
        this.isAudioTrkPlaying = false;
    }

    onDomReady() {
        PGlobal.m.listen(1, 12, proto.com.proto.s.MTabData, (data) => this.onTabData(data));
        PGlobal.m.listen(2, 2, proto.com.proto.editortimeline.MStepsInfo, (data) => this.onSyncStepsInfo(data));
        PGlobal.m.listen(2, 5, proto.com.proto.editortimeline.MStepIndex, (data) => this.onChangeStep(data));
        PGlobal.m.listen(2, 9, null, (data) => this.onPlayComplete(data));
        PGlobal.m.listen(6, 5, null, (data) => this.onSceneInit(data));
        PGlobal.m.listen(6, 21, proto.com.proto.s.MBool, (data) => this.onSyncSaveable(data));
        PGlobal.m.listen(6, 22, proto.com.proto.s.MBool, (data) => this.onSyncPasteable(data));
        PGlobal.m.listen(6, 29, proto.com.proto.editortimeline.MStepIndex, (data) => this.onPlaying(data));
        PGlobal.m.listen(6, 31, proto.com.proto.editortimeline.MPlayTime, (data) => this.onSyncPlayTime(data));
        PGlobal.m.listen(1, 8, proto.com.proto.s.MTimelineToolbarBack, (data) => this.onEditBarChange(data));
        PGlobal.m.listen(6, 37, proto.com.proto.scene.MAudioTRK, (data) => this.onSyncAudioTrk(data));
        PGlobal.m.listen(6, 34, proto.com.proto.s.MBool, (data) => this.onChangeTemplateMode(data));
        PGlobal.m.send(SCENE, 2, 1);
    }

    onTabData(data) {
        this.setup();
    }

    onSceneInit(data) {
        this.timeline.setTemplateMode(false);
    }

    onSyncStepsInfo(data) {
        let stepsInfo = data.data;
        this.timeline.setData(stepsInfo);
    }

    onSyncAudioTrk(data) {
        let trkData = data.data;
        this.timeline.setTrkData(trkData);
    }

    onSpaceClick() {
        if(!this.isPlaying) {
            if(this.isAudioTrkPlaying) {
                this.stopAudioTrk();
            }else {
                this.playAudioTrk();
            }
        }
    }

    playAudioTrk() {
        this.isAudioTrkPlaying = true;
        PGlobal.m.send(SCENE, 6, 41, new proto.com.proto.s.MFloat([this.currentTime/1000.0]));
        this.lastTick = PGlobal.now;
    }

    stopAudioTrk() {
        if(this.isAudioTrkPlaying) {
            this.isAudioTrkPlaying = false;
            PGlobal.m.send(SCENE, 6, 42);
        }
    }

    onChangeStep(data) {
        this.isAudioTrkPlaying = false;
        let stepIndex = data.data;
        // 对齐AS3 TimelineWindow.onChangeStep：仅当切到不同步时隐藏编辑条（SM1_7），同步号回显不动
        // 多选播放推进时不隐藏，保留存模版/删除工具条
        if(stepIndex.step != this.timeline.selected && !this.timeline.data.isMulti){
            this.timeline.hideEditBar();
        }
        this.timeline.changeStep(stepIndex);
    }

    onChangeTemplateMode(data) {
        let bool = data.data.value;
        this.timeline.setTemplateMode(bool);
    }

    onPlayClick(e) {
        this.doPlay();
        let index = this.timeline.selected == this.timeline.length-1 ? 0 : this.timeline.selected;
        let section = new proto.com.proto.editortimeline.MStepSection([[index, this.timeline.page], [-1, this.timeline.page]]);
        PGlobal.m.send(SCENE, 2, 3, section);
    }

    onStopClick(e) {
        this.doStop();
        PGlobal.m.send(SCENE, 2, 4, new proto.com.proto.editortimeline.MStepIndex([this.timeline.selected, this.timeline.page]));
    }

    onSyncSaveable(data) {
        this.save_bt.enable = data.data.value;
    }

    onSyncPasteable(data) {
        this.timeline.pasteable = data.data.value;
    }

    onSaveClick(e) {
        if(this.save_bt.enable) {
            PGlobal.m.send(SCENE, 2, 8);
        }
    }

    onTimelineTimeChange(time) {
        if(this.isAudioTrkPlaying) {
            this.stopAudioTrk();
        }else if(this.isPlaying){
            this.onStopClick();
        }
        this.timeline.setTime(time);
        this.currentTime = time*1000;
        this.freshTime();
        PGlobal.m.send(SCENE+BGMUSIC, 6, 47, new proto.com.proto.s.MFloat([time]));
    }

    onPlayComplete(data) {
        this.doStop();
    }

    onPlaying(data) {
        this.doPlay();
    }

    doStop() {
        if(!this.isPlaying){ return;}
        this.isPlaying = false;
        this.stop_bt.parent.removeChild(this.stop_bt);
        PGlobal.stage.addChild(this.play_bt);
    }

    doPlay() {
        if(this.isPlaying){ return;}
        this.lastTick = PGlobal.now;
        this.isPlaying = true;
        this.play_bt.parent.removeChild(this.play_bt);
        PGlobal.stage.addChild(this.stop_bt);
    }

    onSyncPlayTime(data) {
        let playtime = data.data;
        this.currentTime = playtime.current * 1000;
        this.totalTime = playtime.total * 1000;
        this.freshTime();
        // 对齐AS3 TimelineWindow.onSyncPlayTime：只刷新时间文本，不隐藏编辑条
    }

    freshTime() {
        let date = new Date();
        date.setTime(this.currentTime);
        let current = PGlobal.formatDate("mm:ss", date);
        date.setTime(this.totalTime);
        let total = PGlobal.formatDate("mm:ss", date);
        this.time_tf.text = current + "/" + total;
        this.timeline.setTime(this.currentTime/1000);
    }

    onEditBarChange(data) {
        let msg = data.data;
        if(msg.id == "insertForward") {
            PGlobal.m.send(SCENE, 2, 10, new proto.com.proto.editortimeline.MStepIndex([this.timeline.selected, this.timeline.page]));
        }else if(msg.id == "insertBack") {
            PGlobal.m.send(SCENE, 2, 10, new proto.com.proto.editortimeline.MStepIndex([this.timeline.selected+1, this.timeline.page]));
        }else if(msg.id == "copy") {
            PGlobal.m.send(SCENE, 6, 23);
        }else if(msg.id == "paste") {
            PGlobal.m.send(SCENE, 6, 24);
        }else if(msg.id == "delete") {
            const dict = this.timeline.data.selectDict;
            const max = this.timeline.length - 1;
            const indeies = Object.keys(dict).map(v=>{return parseInt(v)});
            indeies.sort((a, b)=>{return b - a;})
            indeies.forEach(key =>{
                const index = parseInt(key);
                if(index !== max){
                    PGlobal.m.send(SCENE, 2, 11, new proto.com.proto.editortimeline.MStepIndex([index, this.timeline.page]));
                }
            });
            this.timeline.requestPlay(indeies[indeies.length - 1]);
        } else if(msg.id == "timeline_template_save") {
            PGlobal.m.send(SCENE, 2, 13);
        }
    }
}



// WEBPACK FOOTER //
// ./src/common/scripts/pixi/EditorTimeline.js